<template lang="pug">
action-bar(
  :elevation="0"
  :entity="{}"
  no-title
  non-closeable
)
  template(#navbar)
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          text
          rounded
          @click="$emit('clearSelection')"
        )
          v-icon(left) mdi-broom
          | Limpar Seleção
      | Desmarca os itens marcados

  template(#right)

    //- Ações agrupáveis
    v-menu(
      v-for="(category, index) in pins.categories"
      :key="`menu-${category}`"
      offset-y
    )
      template(#activator="{ on, attrs }")
        v-btn(
          v-bind="attrs"
          v-on="on"
          text
          rounded
        )
          v-icon mdi-menu-down
          | {{ category }}
      v-list
        action-bar-menu-item(
          v-for="(action,index) in pins.links.filter(x => x.category === category)"
          :key="`menu-${category}-${index}`"
          :action="action"
          @perform="opts => $emit('perform', { ...opts, selection })"
        )

    //- Ações não agrupáveis
    action-bar-pin(
      v-for="(action,index) in pins.links.filter(x => !x.category)"
      :key="`pin-${index}`"
      :action="action"
      @perform="opts => $emit('perform', { ...opts, selection })"
    )

    //- Botão de atualizar
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn.mx-1(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('refresh')"
        )
          v-icon mdi-refresh
      span
        span.text-md.font-weight-medium Atualizar
        br
        span.font-weight-light Sincroniza os dados da grade com o servidor de dados.

    //- MENU DE AÇÕES
    //-
    v-menu(
      v-if="acts.links.length"
      bottom left offset-y
    )
      template(#activator="{ on, attrs }")
        v-btn.ml-1(
          icon
          v-bind="attrs"
          v-on="on"
        )
          v-icon mdi-dots-vertical
      v-list(dense)
        //- Ações não agrupáveis
        action-bar-menu-item(
          v-for="(action,index) in acts.links.filter(x => !x.category)"
          :key="`menu-${index}`"
          :action="action"
          @perform="opts => $emit('perform', { ...opts, selection })"
        )

        //- Ações agrupáveis
        template(v-for="(category, index) in acts.categories")
          v-subheader {{ category }}

          action-bar-menu-item(
            v-for="(action,index) in acts.links.filter(x => x.category === category)"
            :key="`menu-${category}-${index}`"
            :action="action"
            @perform="opts => $emit('perform', { ...opts, selection })"
          )

    //- BOTÃO FECHAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('clearSelection')"
        )
          v-icon mdi-close
      | Desmarca os itens marcados

</template>

<script lang="js">
import { findRels } from '@/helpers/rels'
import ActionBarMenuItem from '@/components/commons/action-bar/ActionBarMenuItem'
import ActionBarPin from '@/components/commons/action-bar/ActionBarPin'
import ActionBar from '@/components/commons/action-bar/ActionBar'
import GridFilterBtn from './GridFilterBtn'

export default {
  components: {
    ActionBarMenuItem,
    ActionBarPin,
    ActionBar,
    GridFilterBtn,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,

    /**
     * Coleção dos registros selecionados na grade.
     */
    selection: Array,
  },

  computed: {
    dataSet: vm => vm.entity.dataSet || {},
    dataSetActions: vm =>
      vm.dataSet?.links?.filter(x => x.rel && x.rel.includes('Action')) || [],

    acts () {
      const links = [
        ...findRels(this.dataSetActions, 'Primary'),
        ...findRels(this.dataSetActions, 'Secondary'),
        ...findRels(this.dataSetActions, { excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },

    pins () {
      const links = [
        ...findRels(this.dataSetActions, { includes: [ 'Pinned', 'Primary']}),
        ...findRels(this.dataSetActions, { includes: [ 'Pinned', 'Secondary' ]}),
        ...findRels(this.dataSetActions, { includes: [ 'Pinned' ], excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },

    actCategories: vm => vm.acts.categories,
      //[ ...new Set( vm.acts.filter(x => !!x.category).map(x => x.category) ) ],
    pinCategories: vm => vm.pins.categories,
      // [ ...new Set( vm.pins.filter(x => !!x.category).map(x => x.category) ) ],

    set: vm => vm.dataSet.sets?.[0] || {},

    fields: vm => vm.filter?.fields || [],
    searchField: vm => vm.fields.filter(field => vm.isSearchField(field))[0],
  },
}
</script>